import { Link } from "react-router-dom";
import { LOGO } from "@/lib/content";
import { openCookiePrefs } from "@/components/CookieBanner";

export const Footer = () => (
  <footer className="border-t border-line px-5 py-12 sm:px-8" data-testid="site-footer">
    <div className="wrap flex flex-col items-center gap-6 text-center md:flex-row md:justify-between md:text-left">
      <img src={LOGO} alt="Skin Lovers Professional" className="h-6 w-auto opacity-90" />
      <p className="text-xs tracking-wide text-sand">Skin Lovers · Magione (PG)</p>
      <div className="flex gap-6 text-xs text-sand">
        <Link to="/privacy" className="hover:text-gold-light" data-testid="footer-privacy-link">Privacy</Link>
        <button type="button" onClick={openCookiePrefs} className="hover:text-gold-light" data-testid="footer-cookie-btn">Preferenze cookie</button>
      </div>
    </div>
  </footer>
);
